module.exports = __webpack_public_path__ + "static/media/bakri-postpartum-balloon-product.07ce46d1.jpg";